import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from './../../controls/tempRHFControls/RHFSelect';
// import Expense from 'src/models/AP/Expense';
import CreditCardTransactionDetail from 'src/models/AP/CreditCardTransactionDetail';

interface IDefineBudgetCategoryDialogProps {
    dialogName: string;
    selectedExpense: CreditCardTransactionDetail;
    handleCategories?: (category: string, subcategory: string) => void;
    hideDialog: () => void;
}

const DefineBudgetCategoryDialog = (props: IDefineBudgetCategoryDialogProps) => {
    const { register, errors, getValues } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('DefineBudgetCategoryDialog onCreate()');
    };

    const OKClicked = () => {
        props.handleCategories(getValues('category'), getValues('subcategory'));
        props.hideDialog();
    };

    return (
        <Dialog title="Define Budget Category" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <RHFSelect
                        name={`category`}
                        label="Category"
                        options={[
                            { value: 'Category', label: 'Category' },
                        ]}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '20rem' }}
                    />
                    <RHFSelect
                        name={`subcategory`}
                        label="Subcategory"
                        options={[
                            { value: 'Subcategory', label: 'Subcategory' },
                        ]}
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '20rem', marginTop: '1rem' }}
                    />
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default DefineBudgetCategoryDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/DefineBudgetCategoryDialog.tsx